import { motion } from 'framer-motion';

export const ServiceCard = ({ icon: Icon, title, description, features, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5 }}
      className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl hover:border-[#6B7280]/20 transition-all duration-300 group"
      data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="w-14 h-14 bg-gray-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#6B7280] transition-colors duration-300">
        <Icon className="w-7 h-7 text-[#6B7280] group-hover:text-white transition-colors duration-300" />
      </div>
      <h3 className="font-heading font-semibold text-xl text-[#374151] mb-3">
        {title}
      </h3>
      <p className="text-gray-500 leading-relaxed mb-6">
        {description}
      </p>
      {features && (
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2 text-sm text-gray-500">
              <span className="w-1.5 h-1.5 bg-[#6B7280] rounded-full"></span>
              {feature}
            </li>
          ))}
        </ul>
      )}
    </motion.div>
  );
};
